<template>
  <div class="attendancce-punch">
    <div class="pb16">开单打卡</div>
    <div class="mains-content">
      <div class="item_title">统计</div>
      <div class="flex-row">
        <div v-for="(item,index) in statisticalList" :key="index" @click="onClick(item)" class="attendancce-list">
          <img :src="item.icon" alt=""> <span class="ml10 fs16 fb">{{item.name}}</span>
        </div>
      </div>
      <div class="item_title mt30">申请</div>
      <div class="flex-row">
        <div v-for="(item,index) in list" :key="index" @click="onClick(item)" class="attendancce-list" v-perm="{key:'attendancePunch', value: item.auth}">
          <span class="box-img"><img :src="item.icon" alt=""></span> <span class="ml10 fs16 fb">{{item.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [
        {name: '请假', url: '/dataList/companyLeave', icon: require("../../../assets/images/new/askForLeave.png"),auth:'attendancePunch:leave'},
        {name: '打卡异常', url: '/dataList/abnormalAttendance', icon: require("../../../assets/images/new/abnormalAttendance.png"),auth:'attendancePunch:apply'},
        {name: '离职', url: '/manage/companyRecode', icon: require("../../../assets/images/new/departure.png"),auth:'attendancePunch:quit'},
        {name: '合伙人申请', url: '/dataList/staffPromotion', icon: require("../../../assets/images/new/staffPromotion.png"),auth:'attendancePunch:elevate'},
      ],
      statisticalList: [
        {name: '打卡统计', url: '/dataList/attendanceStatistics', icon: require("../../../assets/images/new/statistical.png")},
      ],
      height: this.$store.getters.MainHeight,
      columns: config.columns,
      query: {},
    };
  },
  components: {},
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    onClick (item) {
      this.$router.push(item.url)
    }
    
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.attendancce-punch {
  position: relative;
  padding: 16px 16px 0;
  .attendancce-list {
    width: 200px;
    height: 100px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 10px;
  }
  .box-img {
    display: inline-block;
    width: 48px;
    height: 48px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.mains-content {
  height: calc(100vh - 160px);
  background-color: #fff;
  border-radius: 10px;
  padding: 16px;
}
.item_title {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin-bottom: 24px;
}
</style>